import React from 'react';
import PropTypes from 'prop-types';
import Button from '../base/Button/GlyphedButton';
import {RemoveGlyph} from '../glyphicons/Glyphicons';
import textTranslates from './translate.json';

const DismissButton = ({disabled, onClick}) => {
    return(
        <Button
            disabled={disabled}
            floated="left"
            glyphComponent={<RemoveGlyph className="btn-glyphicon" />}
            id="dismissBtn"
            label={textTranslates.cancelBtnLabel}
            onClick={onClick}/>
    );
};

DismissButton.propTypes = {
    //Should button be disabled
    disabled: PropTypes.bool,
    //Function triggered while button is clicked
    onClick: PropTypes.func
};

export default DismissButton;


// WEBPACK FOOTER //
// ./src/components/Buttons/DismissButton.js